export default __webpack_public_path__ + "static/media/treasurer_signature.42c30e7b.png";